// extracted by mini-css-extract-plugin
module.exports = {"footer_copyright_li":"footer_layout_footer_copyright_li__BxY31"};